(ns dashboard.components.column-visibility-popup
  (:require
   [clojure.string :as str]
   ["react" :as react]
   [io.repliance.ui.util :refer [is-descendant-of?]]))

(defn column-id [column]
  (or (:id column) (:label column)))

(defn column-visibility-popup [{:keys [columns column-visibility on-close on-column-visibility-changed]}]
  (let [[ref set-ref] (react/useState nil)]
    (react/useEffect (fn []
                       (let [click-handler (fn [e]
                                             (when-not (is-descendant-of? (.-target e) ref)
                                               (on-close)))]
                         (js/document.addEventListener "click" click-handler)
                         (fn []
                           (js/document.removeEventListener "click" click-handler))))
                     (array ref))
    [:div {:style {:width 0 :height 0}}
     [:div.card.has-background-white
      {:ref set-ref
       :style {:position "absolute"
               :right 0
               :margin-right "3rem"
               :margin-top "-1rem"
               :z-index 999
               :border-color "black"
               :border-style "solid"
               :width "256px"}}
      [:header.card-header.is-shadowless
       [:p.card-header-title.is-size-5 "Columns"]
       [:button.card-header-icon.is-medium {:on-click on-close}
        [:span.icon>i.fas.fa-circle-xmark]]]
      [:div.card-content.px-4.is-flex.is-flex-direction-column.is-align-items-flex-start
       (->> columns
            (filter (fn [{:keys [label]}]
                      (not (str/blank? label))))
            (map (fn [column]
                   (let [id (column-id column)
                         visible? (get column-visibility id true)]
                     #^{:key (str "column-toggle-" id)}
                     [:label.checkbox.py-2
                      [:input {:type "checkbox"
                               :checked visible?
                               :on-change (fn [e]
                                            (on-column-visibility-changed id (.. e -target -checked)))}]
                      [:span.ml-2 (:label column)]]))))]]]))
